import { makeStyles } from "@material-ui/core/styles";

const useMobileStyles = makeStyles((theme) => ({
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

export { useMobileStyles };
